<template>
  <div>
    <div class="box online_bg">
      <div class="wrap w1200  onsite_b ">
        <!--右侧-->
        <div class="task_kaoshi_list_ok">
          <dl>
            <dt>订单详情</dt>
            <dd class="pay_ok" v-if="payStatus">
              <img src="@/assets/images/pay_ok_icon.png" /><br>支付成功
            </dd>
            <dd class="pay_ok" v-if="!payStatus">
              <img src="@/assets/images/pay_ok_sb.png" /><br>支付失败
              <div>返回首页按钮</div>
            </dd>
            <dd class="pay_text"><span>订单编号:</span>{{businessId}}</dd>
            <dd class="pay_text"><span>商品名称:</span>{{params.productName}}</dd>
            <dd class="pay_text"><span>支付金额:</span>￥{{parseFloat(params.productPrice).toFixed(2)}}</dd>
            <dd class="pay_text"><span>订单日期:</span>{{params.orderCreateDate}}</dd>
            <dd class="pay_text"><span style="display:inline-block;width:60px;height:19px"></span><a class="return_btn" href="javascript:;" @click="returnProductDetail()">返回商品详情</a></dd>
          </dl>
        </div>
        <!--/右侧-->
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import urlutils from '@/utils/urlencode'
export default {
  components: { },
  data () {
    return {
      params: {},
      payStatus: '',
      businessId: this.$route.params.businessId,
      type: this.$route.params.type,
      res_url: this.$route.params.res_url
    }
  },
  created () {
    if (this.$route.params.businessId && this.$route.params.businessId != '' && this.$route.params.businessId != 'Error') {
      this.payStatus = true
      this.judgeType(this.type, this.businessId)
    } else {
      this.payStatus = false
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  computed: {
  },
  methods: {
    judgeType (type, businessId) {
      switch (type) {
        case '1':
          this.enrollReturn(businessId)
          break;
        case '2':
          this.livePlayReturn(businessId)
          break;
        case '3':
          this.courseReturn(businessId)
          break;
        case '4':
          this.examReturn(businessId)
          break;
      }
    },
    enrollReturn (businessId) {
      this.$api.post(this.$global.enrollApiPath, '/signupuser/get', {id: businessId}, r => {
        if (r.data) {
          this.params = r.data
          this.$set(this.params, 'productName', r.data.name)
          this.$set(this.params, 'productPrice', r.data.cost)
          this.$set(this.params, 'orderCreateDate', r.data.updateDate)
        }
      })
    },
    courseReturn (businessId) {
      this.$api.post(this.$global.courseApiPath, '/course/buy/buys', {id: businessId, delFlag: '0'}, r => {
        if (r.data) {
          this.params = r.data[0]
          this.$api.getRestful(this.$global.courseApiPath, '/course/get/' + this.params.courseId, {}, r => {
            this.$set(this.params, 'productName', r.data.name)
            this.$set(this.params, 'productPrice', r.data.coursePriceList[0].price)
            this.$set(this.params, 'orderCreateDate', r.data.createTime)
          })
        }
      })
    },
    livePlayReturn (businessId) {
      this.$api.post(this.$global.livePlayApiPath, '/livePlayPay/findList', {id: businessId, pageNo: 0, pageSize: 0}, r => {
        if (r.data) {
          this.params = r.data[0]
          this.$api.get(this.$global.livePlayApiPath, '/livePlayInfo/get', {id: this.params.livePlayId}, r => {
            this.$set(this.params, 'productName', r.data.name)
            this.$set(this.params, 'productPrice', r.data.cost)
            this.$set(this.params, 'orderCreateDate', r.data.createDate)
          })
        }
      })
    },
    examReturn (businessId) {
      this.$api.post(this.$global.examApiPath, '/examPurchase/search', {id: businessId}, r => {
        if (r.data) {
          this.params = r.data[0]
          this.$set(this.params, 'productName', this.params.title)
          this.$set(this.params, 'productPrice', this.params.point)
          this.$set(this.params, 'orderCreateDate', this.params.createDate)
        }
      })
    },
    returnProductDetail () {
      window.location.href = urlutils.url_decoded(this.res_url)
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/page/modules/pay/result.vue